import React, { useState } from 'react';
import { Languages } from 'lucide-react';
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from '../ui/dialog';
import { Button } from '../ui/button';

const OPTIONS = [
  {
    value: 'english',
    label: 'English',
    description: 'Recommended default for scene-wise synopsis in the PDF.',
  },
  {
    value: 'original',
    label: 'Original Language',
    description: 'Use the screenplay language for scene-wise synopsis.',
  },
];

export const PdfLanguageDialog = ({ open, onClose, onConfirm, loading = false, title = 'Choose PDF synopsis language' }) => {
  const [selected, setSelected] = useState('english');

  return (
    <Dialog open={open} onOpenChange={(nextOpen) => {
      if (!loading && !nextOpen) {
        setSelected('english');
        onClose();
      }
    }}>
      <DialogContent className="sm:max-w-md" data-testid="pdf-language-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2" data-testid="pdf-language-dialog-title">
            <Languages className="h-4 w-4" />
            {title}
          </DialogTitle>
          <DialogDescription data-testid="pdf-language-dialog-description">
            This changes only the scene-wise synopsis shown in the PDF.
          </DialogDescription>
        </DialogHeader>

        <div className="space-y-3 py-2">
          {OPTIONS.map((option) => {
            const active = selected === option.value;
            return (
              <button
                key={option.value}
                type="button"
                onClick={() => setSelected(option.value)}
                className="w-full rounded-xl border px-4 py-3 text-left transition-colors"
                style={{
                  borderColor: active ? 'var(--cb-accent)' : 'var(--cb-border)',
                  background: active ? 'var(--cb-accent-dim)' : 'var(--cb-surface)',
                }}
                data-testid={`pdf-language-option-${option.value}`}
              >
                <div className="text-sm font-bold" style={{ color: 'var(--cb-text)' }}>{option.label}</div>
                <div className="mt-1 text-xs" style={{ color: 'var(--cb-text-dim)' }}>{option.description}</div>
              </button>
            );
          })}
        </div>

        <div className="flex justify-end gap-2 pt-2">
          <Button type="button" variant="outline" onClick={() => { setSelected('english'); onClose(); }} disabled={loading} data-testid="pdf-language-cancel-button">
            Cancel
          </Button>
          <Button type="button" onClick={() => onConfirm(selected)} disabled={loading} data-testid="pdf-language-confirm-button">
            {loading ? 'Generating…' : 'Generate PDF'}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};